.no-usage-left-section {
    min-width: 175px;
    display: flex;
    gap: 16px;
    flex-direction: column;
    height: 100%;
    max-height: 295px;
}

.no-usage-right-section {
    display: flex;
    gap: 16px;
    align-items: center;
    max-height: 295px;
    height: 100%;
}

.no-usage-right-section img,
.no-usage-right-section svg {
    min-height: 100%;
}

.no-usage-right-text {
    min-width: 50%;
    width: 50%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    gap: 8px;
    padding-left: 40px;
    box-sizing: border-box;
}

.leaderboard-section {
    width: 50%;
    height: 264px;
}
